import { TableCell, TableHead, TableRow } from '@mui/material';
import React, { Fragment } from 'react';

const SimpleTableHead = (props) => {
  const { headCells } = props;

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell, headCellIndex) => (
          <Fragment key={'head-cell-' + headCell.code}>
            <TableCell
              align={headCell.numeric ? 'right' : 'left'}
              padding={headCell.disablePadding ? 'none' : 'normal'}
              className='!bg-surface !text-[12px] !font-medium !uppercase !tracking-wide !text-muted'
            >
              <div
                title={
                  headCell.tooltip
                    ? headCell.tooltip.replace(/<[^>]+>/g, '')
                    : undefined
                }
                className={headCell.tooltip ? 'cursor-help' : undefined}
                dangerouslySetInnerHTML={{ __html: headCell.label }}
              />
            </TableCell>
          </Fragment>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default SimpleTableHead;
